// export const STATE_POINTS = {
//     UNANSWERED: 'unanswered',
//     CORRECT: 'correct'
// }

export const GAME_MODES = {
    EXPLORE: 'EXPLORAR',
    PLAY: 'JUGAR',
}

export const TYPE_POINTS = {
    INFO: 'info',   
    SELECTION: 'selection',
    TEXT: 'text'
}

export const STATE_POINT = {
    DEFAULT: 'default',
    CORRECT: 'correct',
    INCORRECT: 'incorrect',
    FOCUS: 'focus'
}

export const MAPA_SOUNDS ={
    GOODACTIVE :"goodActive",
    CHARGE: "charge",
    WRITE: "write",
    MOVE: "move",
    CORRECT: "correct",
    ACTIVATE: "activate",
    PLACE: "place"
}

export const GAMETYPES = {
    BOTH:"ambos",
    DEMO:"demostracion",
    GAME:"juego"
}